import { Box, Dialog, DialogContent, DialogTitle, Grid2, Paper } from '@mui/material';
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { AddTwoTone, Delete, FilterList } from '@mui/icons-material';
import { useColumns } from '../utils/columnsArchivo';
import { Archivominvu, ArchivoMinvuDTO, ArgumentosUpdateArchivoMinvu, DatosArchivoDTO } from '../models/cobroSeguros';
import useArchivoMinvu from '../hooks/useArchivoMinvu';
import TableHeader from '../../../../components/ui/materialui/tableHeader';
import { actualizarArchivoMinvu, datosArchivos, eliminarListadoArchivo } from '../services/segurosServices';
import { SeguroMinvu, StatusCode } from '../../../../utils/enums';
import { descargarExcelCobroSeguro, descargarTxtCobroSeguro } from '../../../detalleMutuo/services/servicesReportes';
import TablaSelector from '../../../../components/ui/materialui/tablaSelector';
import { add } from 'date-fns';
import { useToast } from '../../../../hooks/useToast';

interface IProps {
    show: boolean;
    onHide: () => void;
    data: Archivominvu;
}

interface IFilter {
    fechaDesde: string;
    fechaHasta: string;
}

export interface ListaMINVU {
    idArchivo: number;
    tipoBeneficio: string;
    estado: string;
    fechaGeneracion: Date;
    fechaEnvio: Date;
    nombreArchivo: string;
    descripcionEstado: string;
    descripcionTipoBeneficio: string;
}



const ModalListArchivo: React.FC<IProps> = ({ show, onHide, data }) => {

    const [tablaSeleccionada, setTablaSeleccionada] = useState<ArchivoMinvuDTO[]>([]);
    const { getDataListArchivo, dataListArchivo } = useArchivoMinvu();
    const { addToast } = useToast();


    const { COLUMNS } = useColumns();
    //eslint-disable-next-line
    const columns = useMemo(() => COLUMNS, []);

    useEffect(() => {

        if (!show) return;

        getDataListArchivo(data.id);
        // eslint-disable-next-line
    }, [show]);

    const handleGenerarArchivo = async () => {
        if (dataListArchivo.length === 0) {
            return;
        }
        debugger;
        const tipoSubsidio = data.tiposubsidioCodigo;
        const datos = await datosArchivos(tipoSubsidio);
        if (datos.status !== StatusCode.Ok)
            return;

        const dataRequest: DatosArchivoDTO = await datos.data;

        const respExcel = await descargarExcelCobroSeguro(dataListArchivo, dataRequest.nombreArchivo);
        const respTxt = await descargarTxtCobroSeguro(dataListArchivo, dataRequest.nombreArchivo);

        if (respExcel?.status !== StatusCode.Ok || respTxt?.status !== StatusCode.Ok) {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'No se pudo descargar el archivo MINVU'
            });
            return;
        }


        const requestUpdate: ArgumentosUpdateArchivoMinvu = {
            id: data.id,
            nombreArchivo: dataRequest.nombreArchivo
        };

        const resp = await actualizarArchivoMinvu(requestUpdate);
        if (resp.status !== StatusCode.Ok) {
            addToast({
                mostrar: true,
                titulo: 'Error',
                tipo: 'Danger',
                mensaje: 'No se pudo actualizar el archivo MINVU generado.'
            });
        }
    }

    const handleEliminarArchivos = async () => {
        const resp = await eliminarListadoArchivo(tablaSeleccionada);
        if (resp.status === StatusCode.NoContent) {
            getDataListArchivo(data.id);
        }
    }

    return (
        <Dialog
            open={show}
            onClose={onHide}
            maxWidth="xl"
        >
            <DialogTitle>
                Listado archivo
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>

                            <TablaSelector
                                columns={columns}
                                data={dataListArchivo}
                                setFilaSeleccionada={setTablaSeleccionada}
                                esMultiple
                                titulo={
                                    
                                    <TableHeader
                                        title=""
                                        button={
                                            <MButton
                                                type="button"
                                                variant="contained"
                                                disabled={tablaSeleccionada.length === 0 || data.estado === SeguroMinvu.ESTADOSEGUROMINVU_COBRADO}
                                                onClick={() => { handleGenerarArchivo() }}
                                                startIcon={<AddTwoTone />}
                                            >
                                                Generar archivo MINVU
                                            </MButton>
                                        }
                                        buttonExport={
                                            <MButton
                                                type="button"
                                                variant="contained"
                                                disabled={tablaSeleccionada.length === 0 || data.estado === SeguroMinvu.ESTADOSEGUROMINVU_COBRADO}
                                                onClick={() => handleEliminarArchivos()}
                                                startIcon={<Delete />}
                                            >
                                                Eliminar listado
                                            </MButton>
                                        }
                                    />
                                }
                            />
                            <Grid2 container justifyContent="flex-end" mt={2}>
                                <MButton variant="contained" onClick={onHide} >
                                    Volver
                                </MButton>
                            </Grid2>
                        </Suspense>
                    </Paper>
                </Box>
            </DialogContent>
        </Dialog >
    );
};

export default ModalListArchivo;